import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { Form } from 'react-bootstrap';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const CategoryDropdown = ({ getCategory, categoryID, category,
    getSubCategory, subcategoryID, subcategory,
    getIssueCategory, issueID, issue}) => {
    const [uniqueSubCategorySelect, setUniqueSubCategorySelect] = useState([]);
    const [uniqueIssueCategorySelect, setUniqueIssueCategorySelect] = useState([]); 
    const [categorySelect, setCategorySelect] = useState([]);
    const [subCategorySelect, setSubCategorySelect] = useState([]);
    const [issueCategorySelect, setIssueCategorySelect] = useState([]);
    const [selectedCategoryOption, setSelectedCategoryOption] = useState( categorySelect ? {
        value: categoryID,
        label: category
    }: null);
    const [selectedSubCategoryOption, setSubSelectedCategoryOption] = useState( subCategorySelect ? {
        value: subcategoryID,
        label: subcategory
    }: null);
    const [selectedIssueCategoryOption, setIssueSelectedCategoryOption] = useState( issueCategorySelect ? {
        value: issueID,
        label: issue
    }: null);

    var uniqueCategory;
    var uniqueSubCategory;
    var uniqueIssueCategory;


    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        setSelectedCategoryOption({value: categoryID,
            label: category});
    }, [categoryID, category]);

    useEffect(() => {
        const getCategories = async () => {
            const categoryFromServer = await fetchCategory();
            uniqueCategory = [...new Map(categoryFromServer.map(category => [category["categoryID"], category])).values()];
            uniqueSubCategory = [...new Map(categoryFromServer.map(category => [category["subcategoryID"], category])).values()];
            uniqueIssueCategory = [...new Map(categoryFromServer.map(category => [category["issueID"], category])).values()];

            setUniqueSubCategorySelect(uniqueSubCategory);
            setUniqueIssueCategorySelect(uniqueIssueCategory);
            const subcategoryitem = uniqueSubCategory.filter(
                (category) => category.categoryID === categoryID
            );
            const issueitem = uniqueIssueCategory.filter(
                (category) => category.subcategoryID === subcategoryID
            );
            setCategorySelect(uniqueCategory);
            setSubCategorySelect(subcategoryitem);
            setIssueCategorySelect(issueitem);
        };

        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryID, subcategoryID]);

    // Fetch Categories
    const fetchCategory = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getcategorylist'
        );
        const data = await res.json();

        return data.grievanceIssueList;
    };

    const optionCategory = categorySelect.map((category, index) => {
        return {
            value: category.categoryID,
            label: category.categoryName
        }
    })

    const optionSubCategory = subCategorySelect.map((subcategory, index) => {
        return {
            value: subcategory.subcategoryID,
            label: subcategory.subcategoryName
        }
    })

    const optionIssueCategory = issueCategorySelect.map((issuecategory, index) => {
        return {
            value: issuecategory.issueID,
            label: issuecategory.issueName
        }
    })

    const handleChange = (selectedCategoryOption) => {
        setSelectedCategoryOption(selectedCategoryOption);
        setSubCategorySelect([]);
        setSubSelectedCategoryOption([]);
        setIssueCategorySelect([]);
        setIssueSelectedCategoryOption([]);
        getIssueCategory([]);
        getSubCategory([]);
        if (selectedCategoryOption) {
            const subcategoryitem = uniqueSubCategorySelect.filter(
                (category) => category.categoryID === selectedCategoryOption.value
            );
            setSubCategorySelect(subcategoryitem);
            getCategory(selectedCategoryOption.value);
        }
    };

    const handleChangeSubCategory = (selectedSubCategoryOption) => {
        setSubSelectedCategoryOption(selectedSubCategoryOption);
        setIssueCategorySelect([]);
        setIssueSelectedCategoryOption([]);
        getIssueCategory([]);
        if (selectedSubCategoryOption) {
            const issueitem = uniqueIssueCategorySelect.filter(
                (category) => category.subcategoryID === selectedSubCategoryOption.value
            );
            setIssueCategorySelect(issueitem);
            getSubCategory(selectedSubCategoryOption.value);
        }
    };

    const handleChangeIssue = (selectedIssueCategoryOption) => {
        setIssueSelectedCategoryOption(selectedIssueCategoryOption);

        if (selectedIssueCategoryOption) {
            getIssueCategory(selectedIssueCategoryOption.value)
        }
    };

    return (
        <div>
            <Form.Group className='mb-3'>
                <Form.Label>Category</Form.Label>
                <Select
                placeholder={'Select a Category...'}
                components={{ Control: ControlComponent }}
                value={selectedCategoryOption}
                onChange={handleChange}
                options={optionCategory}
                isClearable
                />
            </Form.Group>
            <Form.Group className='mb-3'>
                <Form.Label>Sub Category</Form.Label>
                <Select
                placeholder={'Select a Sub Category...'}
                components={{ Control: ControlComponent }}
                value={selectedSubCategoryOption}
                onChange={handleChangeSubCategory}
                options={optionSubCategory}
                isClearable
                />
            </Form.Group>
            <Form.Group className='mb-3'>
                <Form.Label>Issue</Form.Label>
                <Select
                placeholder={'Select a Issue Category...'}
                components={{ Control: ControlComponent }}
                value={selectedIssueCategoryOption}
                onChange={handleChangeIssue}
                options={optionIssueCategory}
                isClearable
                />
            </Form.Group>
        </div>
    );
};

export default CategoryDropdown;
